import React from 'react'
import styled from 'styled-components'
import {_L, useLocaleState} from '../../../../context/LocaleContext'
import {formatDate} from '../../../../utils/time'

const ServiceRequestDetailProgressBar = ({request}) => {
  const localeState = useLocaleState()
  const {dateRequested, dateScheduled, dateCompleted} = request
  let dateRequestedFormat
  let dateScheduledFormat
  let dateCompletedFormat
  let progress = 0
  if (dateRequested) dateRequestedFormat = formatDate(dateRequested, 'L')
  if (dateScheduled) {
    dateScheduledFormat = formatDate(dateScheduled, 'L')
    progress = 50
  }
  if (dateCompleted) {
    dateCompletedFormat = formatDate(dateCompleted, 'L')
    progress = 100
  }

  return (
    <div>
      <Steps>
        <ProgressBarContainer>
          <ProgressBar progress={progress} />
        </ProgressBarContainer>
        <Step done={!!dateRequestedFormat}>
          <Header>
            {_L({
              key: 'Requested',
              localeState
            })}
          </Header>
          <Node style={{margin: '0 auto 0 0'}} done />
          <Footer>{dateRequestedFormat}</Footer>
        </Step>
        <Step done={!!dateScheduledFormat}>
          <Header>
            {_L({
              key: 'Scheduled',
              localeState
            })}
          </Header>
          <Node />
          <Footer>{dateScheduledFormat}</Footer>
        </Step>
        <Step done={!!dateCompletedFormat}>
          <Header>
            {_L({
              key: 'Completed',
              localeState
            })}
          </Header>
          <Node style={{margin: '0 0 0 auto'}} />
          <Footer>{dateCompletedFormat}</Footer>
        </Step>
      </Steps>
    </div>
  )
}

export default ServiceRequestDetailProgressBar

const ProgressBarContainer = styled.div`
  left: 16px;
  right: 16px;
  position: absolute;
  height: 6px;
  background-color: #f3f5fb;
  top: 50%;
  transform: translateY(-50%);
`

const ProgressBar = styled.div`
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: ${props => props.progress}%;
  background-color: #3395fe;
`

const Steps = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 10px 0 0;
  position: relative;
`

const Node = styled.div`
  height: 20px;
  width: 20px;
  background-color: #f3f5fb;
  border-radius: 50%;
  position: relative;
  margin: 0 auto;
`

const Step = styled.div`
  text-align: center;
  position: relative;
  color: #3395fe;
  display: flex;
  flex-direction: column;
  ${Node} {
    ${props => props.done && 'background-color: #3395fe;'};
  }
`
const Header = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #a4a9b7;
  padding-bottom: 9px;
`

const Footer = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #000000;
  padding-top: 9px;
`
